/* prettier-ignore */

import { Component, AfterViewInit } from '@angular/core';
import { TranslationService } from 'src/app/services/translation.service';
import { RestService } from 'src/app/services/rest.service';
import { ToolsService } from 'src/app/services/tools.service';

@Component({
  selector: 'google-translate',
  templateUrl: './google-translate.component.html',
  styleUrls: ['./google-translate.component.css']
})
export class GoogleTranslateComponent implements AfterViewInit {

  public ISOCodesArray: any = [];

  constructor(private translationService: TranslationService, private rest: RestService, private tools: ToolsService){
    this.ISOCodesArray = this.translationService.allGoogleLanguages.map(lang => lang.code)?.join(',');
  }

  ngAfterViewInit() {
    if (this.tools.isWebApp())
      return;
    
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
    document.body.appendChild(script);

    (window as any).googleTranslateElementInit = () => {
      new (window as any).google.translate.TranslateElement(
        {
          pageLanguage: this.rest.device()?.mainLanguage || 'es',
          includedLanguages: this.ISOCodesArray,
          autoDisplay: false,
          layout: (window as any).google.translate.TranslateElement.InlineLayout.SIMPLE
        },
        'google_translate_element'
      );
    };
  }

  preventReload(e: any){
    e.preventDefault();
  }
}